export class DbTransform {

    dbt: boolean;

    enviromentOracleList = ['kalciyan', 'reina'];

 constructor(
    public enviromentIn: string
 ) {

    // Aquí se colocarían los entornos que vayan a llevar asociados una base de datos ORACLE.
    if (this.enviromentOracleList.includes(enviromentIn)) {
        // console.log('->-< DbTransform Base de datos ORACLE encontrada.');
        this.dbt = false;
    } else {
        this.dbt = true;
    }

    // console.log('-> DbTransform Mysql database:' + this.dbt);
 }

// Función que transforma el nombre de la columna para adaptarlo
// al tipo de dialecto de la base de datos que estemos utilizando.
 t(value: string): string {
    // console.log('-> Campo tabla db:' + value);

    if (this.dbt) {
        // console.log(value.toLocaleLowerCase());
        return value.toLocaleLowerCase();
    } else {
        // console.log(value.toLocaleLowerCase());
        return value.toLocaleUpperCase();
    }
 } // End function dbt

 setDbt(value: boolean) {
    this.dbt = value;
 }

} // End class DbTransform